export const STORAGE_KEY = 'user_jwt_access_token';
